import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from './angular-material.module';
import { LoaderComponent } from './components/loader/loader.component';
import { SafeHTMLPipe } from './pipes/safe-html.pipe';
import { FormatDatePipe } from './pipes/format-date.pipe';
@NgModule({
  declarations: [LoaderComponent, SafeHTMLPipe, FormatDatePipe],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    LoaderComponent,
    SafeHTMLPipe,
    FormatDatePipe,
  ],
  providers: [SafeHTMLPipe, FormatDatePipe],
})
export class SharedModule {}
